import { Injectable } from "@angular/core";
import { NavTreeNode } from "../../interface/tree";
import { NavTreeNodeIconService } from "../node-icon";

const ICON_CLASS_PREFIX = 'nav-treenode-icon nav-treenode-icon--';
const ICON_CLASS_SUFFIX_MAP = {
  '.ts': 'ts',
  '.webcmp': 'webcmp',
  '.webcmd': 'webcmd'
};

/**
 * 一般导航树节点图标服务
 * @remarks
 * 该图标服务根据path中的文件后缀名为节点匹配图标
 * 如果用户未传入图标服务，且未在节点中设置icon等字段，则将该服务作为默认图标服务
 */
@Injectable()
export class CommonNodeIconService extends NavTreeNodeIconService {

  public setIconProp(nodes: NavTreeNode[]): void {
    for (const node of nodes) {
      this.setRootNodeIcon(node);
    }
  }

  private setRootNodeIcon(node: NavTreeNode): void {
    if (!node) {
      return;
    }
    this.setIcon(node, this.getIconClassByPath(node.data.path));
    // 递归的为该节点的子节点设置图标类
    if (node.children && node.children.length > 0) {
      for (const child of node.children) {
        this.setRootNodeIcon(child);
      }
    }
  }

  private setIcon(node: NavTreeNode, icon: string): void {
    if (!node || !icon) {
      return;
    }
    // 如果已经设置了图标，则不再继续修改
    if (node.icon && node.expandedIcon && node.collapsedIcon) {
      return;
    }
    node.icon = icon;
    node.expandedIcon = icon;
    node.collapsedIcon = icon;
  }

  private getIconClassByPath(path: string): string {
    const suffix = this.getFileSuffix(path);
    if (!suffix) {
      return ICON_CLASS_PREFIX + 'default-folder';
    }
    if ( ICON_CLASS_SUFFIX_MAP[suffix] ) {
      return ICON_CLASS_PREFIX + ICON_CLASS_SUFFIX_MAP[suffix];
    }
    return ICON_CLASS_PREFIX + 'default-file';
  }

  private getFileSuffix(path: string): string {
    path = path.replace(/\\/g, '/');
    const idx = path.lastIndexOf('.');
    if (idx >= 0) {
      const suffix = path.substring(idx);
      if ( suffix.includes('/') ) {
        return '';
      }
      return suffix;
    }
    return "";
  }

}
